import { jsx as _jsx } from "react/jsx-runtime";
import { ApiFactoryInstance } from '../api';
import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthenticationContext';
const UserAccountsContext = createContext(undefined);
export const UserAccountsProvider = ({ children, initialSelectedAccountId, onSelectedAccountChange }) => {
    const [loaded, setLoaded] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [selectedAccountId, setSelectedAccountId] = useState(initialSelectedAccountId);
    const [defaultAccountId, setDefaultAccountId] = useState(undefined);
    const { authenticated } = useAuth();
    const loadAccounts = async () => {
        const userAccountsResponse = await ApiFactoryInstance.getUserAccountsApi()?.getAccounts();
        setAccounts(userAccountsResponse ? userAccountsResponse.accounts : undefined);
        const defaultId = userAccountsResponse?.defaultAccount || undefined;
        setDefaultAccountId(defaultId);
        // Auto-select default account if no account is currently selected
        if (!selectedAccountId && defaultId) {
            setSelectedAccountId(defaultId);
            onSelectedAccountChange?.(defaultId);
        }
    };
    useEffect(() => {
        console.log('UserAccountsProvider useEffect with authenticated:', authenticated);
        if (!authenticated) {
            return;
        }
        const load = async () => {
            await loadAccounts();
            setLoaded(true);
        };
        load();
    }, [authenticated]);
    const addAccount = async (accountId, nickName) => {
    };
    const updateAccountNickname = async (accountId, nickName) => {
    };
    const selectAccount = async (accountId) => {
        const account = accounts?.find(account => account.id === accountId);
        if (account) {
            setSelectedAccountId(accountId);
            onSelectedAccountChange?.(accountId);
        }
    };
    const refreshAccounts = async () => {
        await loadAccounts();
    };
    return (_jsx(UserAccountsContext.Provider, { value: {
            loaded, accounts, selectedAccountId, selectAccount, defaultAccountId,
            addAccount, updateAccountNickname, refreshAccounts
        }, children: children }));
};
export const useUserAccounts = () => {
    const context = useContext(UserAccountsContext);
    if (!context) {
        throw new Error('useUserAccounts must be used within a UserAccountsProvider');
    }
    return context;
};
